export enum DisputesHistoryDialogFormLabelsEnum {
  TITLE = 'Dispute History',
  DISPUTE_NUMBER = 'Dispute #',
  CURRENT_STATUS = 'Current Status',
  LAST_UPDATED_DATE = 'Last Updated By',
  LAST_UPDATED_BY = 'Last Updated On',
}
